import { render, staticRenderFns } from "./AllPlanets.vue?vue&type=template&id=2c50dd88"
import script from "./AllPlanets.vue?vue&type=script&lang=js"
export * from "./AllPlanets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c50dd88')) {
      api.createRecord('2c50dd88', component.options)
    } else {
      api.reload('2c50dd88', component.options)
    }
    module.hot.accept("./AllPlanets.vue?vue&type=template&id=2c50dd88", function () {
      api.rerender('2c50dd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/AllPlanets.vue"
export default component.exports